import {
  CHANGE_CATALOGUE_PAGE,
  FETCH_CATALOGUE_PAGE, GET_LOY3_CATALOGUE_HOTELS,
} from '../constants';
import { userConstants } from '../constants/user.constants';

const initialState = () => ({
  loy3Hotels: [],
  cataloguePages: {},
  currentPage: 1, // paginator pages start at 1
  totalItems: 0,
  pageSize: 10,
});

export const catalogue = (state = initialState(), action) => {
  switch (action.type) {
    case FETCH_CATALOGUE_PAGE:
      const { rewards, totalItems, pageNumber } = action;
      // When fetching the first page, it means filters etc changed, so we need to clear previous data
      if (pageNumber === 1) {
        return {
          ...state,
          currentPage: pageNumber,
          totalItems,
          cataloguePages: {
            [pageNumber]: rewards,
          },
        };
      }
      const updatedPages = {...state.cataloguePages};
      updatedPages[action.pageNumber] = rewards;
      return {
        ...state,
        currentPage: pageNumber,
        cataloguePages: updatedPages,
      };
    case CHANGE_CATALOGUE_PAGE:
      return {
        ...state,
        currentPage: action.pageNumber,
      };
    case GET_LOY3_CATALOGUE_HOTELS:
      return {
        ...state,
        loy3Hotels: action.loy3Hotels || [],
      };
    case userConstants.LOGOUT:
      return initialState();
    default:
      return state;
  }
}

